import styled from 'styled-components';
import { border, BorderProps, color, ColorProps, height, HeightProps, padding, PaddingProps, width, WidthProps } from 'styled-system';

type StyledOTPprops = {
  outlineColor?: string;
} & BorderProps &
  ColorProps &
  WidthProps &
  HeightProps &
  PaddingProps;

export const StyledOTP = styled.input<StyledOTPprops>(
  border,
  color,
  width,
  height,
  padding,
  {
    color: 'rgb(39, 157, 46) !important',
    fontSize: '40px !important',
    borderBottomStyle: 'solid',
    userSelect: 'none',
    caretColor: 'transparent',
    '&::selection': {
      backgroundColor: 'transparent',
    },
    textAlign: 'center',
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  (props) => ({
    'outline-color': props.outlineColor,
  })
);

StyledOTP.defaultProps = {
  borderTop: '0px',
  borderLeftWidth: '0px',
  borderRightWidth: '0px',
  borderBottomWidth: '2px',
  width: '100% !important',
  padding: '0px !important',
  height: '50px !important',
};
